import {json} from '../core/data-source/json.mapper';

export class PriorityRecord {
    @json({
        mapper: {
            from: (val: number, record) => (val ? val : record.value)
        }
    })
    id: number;

    @json() value: number;

    @json() name: string;

    @json() color: string;
}
